import { useDispatch, useSelector } from "react-redux";
import Button from "@shared/v2/Button";
import TextLink from "@shared/v2/TextLink";
import { deleteInteractionTemplate, setDeleteTemplate } from "../../reducers/interactionTemplatesReducer";
import DeleteTemplateModal from "../DeleteTemplateModal";
import type { InteractionTemplatesState } from "./types";

const DeleteInteractionTemplateModal = () => {
  const dispatch = useDispatch();
  const deleteTemplate = useSelector(
    (state: InteractionTemplatesState) => state.interactionTemplates.deleteTemplate,
  );
  const loading = useSelector(
    (state: InteractionTemplatesState) => state.interactionTemplates.interactionTemplates.loading,
  );
  const hasFutureInteractions = deleteTemplate?.futureInteractions !== 0;

  const onDelete = (archive = false) =>
    // @ts-expect-error untyped thunk
    dispatch(deleteInteractionTemplate({ template: deleteTemplate, ...(archive ? { archive } : {}) }));

  return (
    <DeleteTemplateModal
      show={Boolean(deleteTemplate)}
      onClose={() => dispatch(setDeleteTemplate(null))}
      onConfirm={() => onDelete()}
      loading={loading}
      extraActions={
        hasFutureInteractions ? (
          // @ts-expect-error props
          <Button onClick={() => onDelete(true)} size="medium" schema="tertiary">
            Send & Delete
          </Button>
        ) : null
      }
    >
      <p className="tw-m-0">
        Are you sure you want to delete this template?{" "}
        {deleteTemplate?.actionPlans?.length ? (
          <>
            This email Template is being used in {deleteTemplate.actionPlans.length} People Action Plans.
            Before deleting it we recommend you update them.
          </>
        ) : null}
      </p>
      <ul className="tw-m-0">
        {deleteTemplate?.actionPlans?.map(({ name, href }) => (
          <li key={href}>
            {/* @ts-expect-error props */}
            <TextLink href={href} target="_blank">
              {name}
            </TextLink>
          </li>
        ))}
      </ul>
      {hasFutureInteractions && (
        <p className="tw-m-0">
          Would you still like to send any pre-scheduled emails that came from this template? There are{" "}
          {deleteTemplate?.futureInteractions} pre-scheduled emails to be sent.
        </p>
      )}
    </DeleteTemplateModal>
  );
};

export default DeleteInteractionTemplateModal;
